import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  handleSubmit(event) {
    const response_body = $(event.currentTarget).find("#response_body");
    event.detail.fetchResponse.responseText.then((value) => {
      response_body.html("<xmp>" + value + "</xmp>");
    });
  }
}
